import { useCallback, useEffect, useRef, useState } from 'react'
import { supabase, supabaseConfigured } from '../lib/supabaseClient'
import { useAuth } from '../contexts/AuthContext'

// Read-only N-day window of intake_log rows for the current user.
// Powers the adherence-streak math. Kept separate from `useIntakeLog`
// (single-day + mutation-capable) so the today checklist and the
// historical streak query don't fight over the same state.
export function useIntakeHistory({ days = 90 } = {}) {
  const { user } = useAuth()
  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const initialLoadedRef = useRef(false)

  const fetch = useCallback(async () => {
    if (!supabaseConfigured || !user) {
      setLoading(false)
      return
    }
    if (!initialLoadedRef.current) setLoading(true)
    setError(null)
    const sinceMs = Date.now() - days * 24 * 60 * 60 * 1000
    const sinceIso = new Date(sinceMs).toLocaleDateString('en-CA')
    const { data, error: err } = await supabase
      .from('intake_log')
      .select('item_kind, item_id, date, scheduled_time')
      .eq('user_id', user.id)
      .gte('date', sinceIso)
    if (err) setError(err.message)
    else setRows(data || [])
    initialLoadedRef.current = true
    setLoading(false)
  }, [user, days])

  useEffect(() => { fetch() }, [fetch])

  return { rows, loading, error, refetch: fetch }
}
